import { render } from "./ManageRealtime.vue?vue&type=template&id=56f83c94"
import script from "./ManageRealtime.vue?vue&type=script&lang=js"
export * from "./ManageRealtime.vue?vue&type=script&lang=js"

import "./ManageRealtime.vue?vue&type=style&index=0&id=56f83c94&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__